import { IContentHeadingTemplate } from '@dadohr/shared/domainTypes/experience';
import { useTheme } from '@emotion/react';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core';
import { SetStateAction } from 'react';
import { TokenDefinition } from '../../../../../../../../components/MarkdownText';
import { TextAlignToggleButtonGroupWithLabel } from '../../../../../../../../components/TextAlignToggleButtonGroup';
import { TextFieldWithReplacementTokens } from '../../../../../../../../components/TextFieldWithReplacementTokens';
import { useUnsafeTranslation } from '../../../../../../../../i18next';
import { FlexContainer } from '../../../../../../../../layout/Flex';
import { TaskBuilderContext } from '../../../types';
import {
  TaskBuilderBlockValidationState,
  TaskBuilderBlockValidationStateItem,
  useFieldValidator,
  VALIDATORS_HEADING
} from '../../../validation';

export const BlockSettingsContentHeading = ({
  value,
  onChange,
  validation,
  setValidation,
  expTpl,
  tokens
}: {
  value: IContentHeadingTemplate;
  onChange: (nextValue: IContentHeadingTemplate) => void;
  validation: TaskBuilderBlockValidationStateItem | null;
  setValidation: React.Dispatch<
    SetStateAction<TaskBuilderBlockValidationState>
  >;
  expTpl: TaskBuilderContext;
  tokens: TokenDefinition[];
}) => {
  const { t } = useUnsafeTranslation();
  const theme = useTheme();
  const validateHeading = useFieldValidator(
    setValidation,
    VALIDATORS_HEADING,
    'heading'
  );
  const invalidHeadingReason = validation?.fields.heading || null;
  return (
    <FlexContainer
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
    >
      <RadioGroup
        aria-label="Size"
        name="Size"
        value={value.data.size || 'M'}
        row
        style={{ gap: theme.spacing(3) }}
        onChange={(ev) => {
          const nextValue: IContentHeadingTemplate = Object.assign({}, value, {
            data: Object.assign({}, value.data, {
              ...value.data,
              size: ev.target.value as 'M' | 'L'
            })
          });
          onChange(nextValue);
        }}
      >
        <FormControlLabel
          value="L"
          control={<Radio color="primary" />}
          label={<Typography variant="h3">{t('Large')}</Typography>}
        />
        <FormControlLabel
          value="M"
          control={<Radio color="primary" />}
          label={<Typography variant="h5">{t('Medium')}</Typography>}
        />
      </RadioGroup>
      <TextFieldWithReplacementTokens
        autoFocus
        value={value.data.t}
        fullWidth
        variant="outlined"
        onBlur={() => validateHeading(value, expTpl)}
        error={!!invalidHeadingReason}
        helperText={invalidHeadingReason}
        onChange={(nextT) => {
          const nextValue: IContentHeadingTemplate = Object.assign({}, value, {
            data: Object.assign({}, value.data, {
              ...value.data,
              t: nextT
            })
          });

          invalidHeadingReason && validateHeading(nextValue, expTpl);
          onChange(nextValue);
        }}
        tokens={tokens}
      />
      <TextAlignToggleButtonGroupWithLabel
        value={value.data.textAlign || 'left'}
        onChange={(nextAlign) => {
          const nextValue: IContentHeadingTemplate = Object.assign({}, value, {
            data: Object.assign({}, value.data, {
              ...value.data,
              textAlign: nextAlign
            })
          });
          onChange(nextValue);
        }}
      />
    </FlexContainer>
  );
};

export const BlockSettingsContentHeadingReadOnly = ({
  value
}: {
  value: IContentHeadingTemplate;
}) => null;
